import {cerrarSesion} from '../utilities/Seguridad'
import axios from 'axios'

export async function getLista(idColegio,anio,token) {
 
    let config = {
        method: 'get',
        url: `${process.env.REACT_APP_URL}/colegio/${idColegio}/ficha-estudiante/${anio}`,
        headers: { 
          'Authorization': `Bearer ${token}`
        }
      };
      
      const response =  await axios(config)
      .then((response) => {
        if(response.data.error===1) cerrarSesion(response.data);
        return response.data;
      })
      .catch((error) => {
        console.log(error);
        return null;
      });
      return response;
} 

export async function getListaGrado(idColegio,anio,token) {
 
  let config = {
      method: 'get',
      url: `${process.env.REACT_APP_URL}/colegio/${idColegio}/grados/${anio}`,
      headers: { 
        'Authorization': `Bearer ${token}`
      }
    };
    
    const response =  await axios(config)
    .then((response) => {
      if(response.data.error===1) cerrarSesion(response.data);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return null;
    });
    return response;
} 

